<template>
  <div class="zusatzbaustein-table">
    <v-row class="mylabels" no-gutters>
      <v-spacer />

      <v-col cols="3"
             class="zusatz--column">
        <span>Selbstbeteiligung</span>
      </v-col>

      <v-col cols="3"
             class="zusatz--column">
        <span>{{ praemienName('' + zahlweise) }}</span>
      </v-col>
    </v-row>

    <hr class="v-divider first">

    <template v-for="(item, index) in items">
      <hr v-if="index > 0"
          :key="'divider' +  index"
          class="v-divider">
      <v-row :key="'zusatz' + index" no-gutters>
        <v-col cols="6">
          <v-row no-gutters
                 align="start"
                 class="flex-nowrap checkbox-container">
            <label :key="'content' + index"
                   class="mr-1 cursor--pointer"
                   @click="(disabled || !isAvailable(item.productKey)) ? showSnackbar(item.productKey) : true">
              <v-row no-gutters
                     align="start"
                     class="flex-nowrap">
                  <v-checkbox v-model="values[item.productKey]"
                              :disabled="disabled || isFree(item.productKey) || !isAvailable(item.productKey) || isIncluded(item.productKey)"
                              hide-details
                              @change="setZusatzbaustein($event, item.productKey)" />
                {{ item.label }}
              </v-row>
            </label>
            <div v-if="disabled || !isAvailable(item.productKey)"
                 class="checkbox-overlay"
                 @click="showSnackbar(item.productKey)">
            </div>
            <site-tooltip v-if="item.info"
                          :titel="item.info.title"><div v-html="item.info.content"/>
            </site-tooltip>
          </v-row>
          <template v-if="isIncluded(item.productKey)">
            <div class="theme--light v-messages v-messages__message ml-8">bereits im Leistungsumfang PRESTIGE enthalten</div>
          </template>
        </v-col>

        <template v-if="item.productKey !== 'SPEZ-PRIVVM'">
          <v-col cols="3"
                 class="zusatz--column">
            <span v-if="matrixSelection.sb.gewerbe"
                  data-cy="zusatzbaustein-sb">{{ getSb(item) }} €</span>
          </v-col>

          <v-col cols="3"
                 class="zusatz--column">
            <span v-if="isFree(item.productKey)">mitversichert</span>
            <span v-else-if="prices && deckungen.length"
                  data-cy="zusatzbaustein-praemie">{{ prices[index] ? $helpers.formatCurrency(prices[index]) : '' }}</span>
          </v-col>
        </template>

        <v-col v-else
               cols="12">
          <zusatz-wohnungen v-if="values[item.productKey]"
                            :person-ref="personRef">
          </zusatz-wohnungen>
        </v-col>

        <v-col v-if="item.productKey === 'MIETZ' && values['MIETZ']"
               cols="12">
          <dmb-accordion ref="accordionStep2Immo"
                         :key="'immoaccordion' + index"
                         :items="immobilienVerm"
                         component-name="immobilieData"
                         :allow-delete="true"
                         state-path="gewerbe.ui.accordions.step2Immo"
                         @remove="removeImmobilie(...arguments)"/>
          <add-button text="gewerblich verpachtete Immobilie hinzufügen"
                      @add="addImmobilieVerm" />
        </v-col>
      </v-row>

    </template>

  </div>
</template>
<script>
//import DmbAccordion from '@/components/gewerberechner/DmbAccordion';
import { mapGetters, mapState } from 'vuex';
import ZusatzWohnungen from '@/components/gewerberechner/ZusatzWohnungen';
import AddButton from "@/components/gewerberechner/AddButton";
import immobilienConfig from '@/store/config/immobilie';
import keyTranslatorMixin from '@/components/helper/keyTranslatorMixin';

export default {
  name: "ZusatzbausteinTabelle",
  components: { AddButton, DmbAccordion: () => import('./DmbAccordion'), ZusatzWohnungen },
  mixins: [keyTranslatorMixin],
  props: {
    items: {
      type: Array,
      required: true
    },
    personRef: {
      type: String,
      required: true
    },
    gewerbe: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      values: {},
      prices: null,
      unitLabels: immobilienConfig.unit,
      objektBezug: immobilienConfig.bezug,
      objektArt: immobilienConfig.art           
    };
  },
  computed: {
    ...mapState({
      mitarbeiter: state => state.gewerbe.mitarbeiter,
      deckungen: state => state.gewerbe.deckungen,
      zahlweise: state => state.gewerbe.vertrag.zahlweise,
      laufzeit: state => state.gewerbe.vertrag.laufzeit,
      matrixSelection: state => state.gewerbe.ui.matrixSelection,
      excludeGF: state => state.gewerbe.ui.excludeGF
    }),
    ...mapGetters([
      'gewerbeProductSelected',
      'gewerbeProductAvailable',
      'gewerbeDeckungPrice',
      'gewerbePrice',
      'ersterGF',
      'anzahlMitarbeiter'
    ]),
    disabled() {
      return this.matrixSelection.produkte.filter(p => /^SPEZ-PBV*/.test(p)).length === 0 || !this.gewerbe && this.excludeGF;
    },
    immobilienVerm() {
      return this.$store.state.gewerbe.immobilien
        .filter(immo => immo.art === 'VERMIET')
        .map((immo, i) => {
          const formatedUnitValue = `Jahresbruttopacht ${this.$helpers.toGermanIntegerString(immo.value)} ${this.getObjektArt(immo).shortunit}`;          
          const formatedPrice = this.getBeitrag(immo.key) ?  ` / ${this.praemienName('' + this.zahlweise)} ${this.$helpers.toGermanFloatString(this.getBeitrag(immo.key))} €` : "...";
          return {
            key: immo.key,
            label: `Immobilie ${i + 1}`,
            name: this.getBeitrag(immo.key) ? `${formatedUnitValue} ${formatedPrice}` : "",
            statePath: this.$store.getters.immobiliePath(immo.key)
          };
        }, this);
    },
    isSsrFree() {
      return this.isFree('SPEZ-PRIVSSR');
    },
    isZwIncluded() {
      return this.gewerbeProductSelected('SPEZ-PRIVPRESTIGE', this.personRef);
    }
  },
  watch: {
    matrixSelection: {
      deep: true,
      handler() {
        this.setPrices();
        if (this.matrixSelection.produkte.filter(p => /^SPEZ-PBV*/.test(p)).length === 0) {
          this.deselectAllZusatzbausteine();
        }
      }
    },
    zahlweise() {
      this.setPrices();
    },
    laufzeit() {
      this.setPrices();
    },
    anzahlMitarbeiter() {
      this.setPrices();
    },
    excludeGF(value) {
      if (!this.gewerbe && value) this.deselectAllZusatzbausteine();
    },
    isSsrFree(value) {
      this.setZusatzbaustein(value, 'SPEZ-PRIVSSR');
    },
    isZwIncluded(value) {
      if (value) this.setZusatzbaustein(false, 'SPEZ-PRIVZW');
    }
  },
  mounted() {
    this.items.forEach(item =>
      this.$set(this.values, item.productKey, this.gewerbeProductSelected(item.productKey, this.personRef) || this.isFree(item.productKey)
    ));
    if (this.matrixSelection.sb.gewerbe) this.setPrices();
  },
  methods: {
    setPrices() {
      this.prices = this.items.map(item => this.gewerbePrice(this.matrixSelection.sb, item.productKey, this.mitarbeiter,
        null, null, [], this.laufzeit, this.zahlweise));
    },
    getSb(item) {
      if( item.productKey === 'SPEZ-T') return '500'; //SB500 fix für Firmen-Vertrats-Rechtsschutz
      if( item.privat){
        return item.productKey === 'SPEZ-PRIVCYBER' ? '150' : this.matrixSelection.sb.privat;
      } else {
        return item.productKey === 'SPEZ-SSRG' ? '0' : this.matrixSelection.sb.gewerbe;
      }
    },
    deselectAllZusatzbausteine() {
      this.items.forEach(item => this.setZusatzbaustein(false, item.productKey));
    },
    setZusatzbaustein(value, produkt) {
      this.values[produkt] = value;
      const _isFree = this.isFree(produkt);
      if (value && !_isFree) {

        if( produkt === "MIETZ" ) {
          if(!this.immobilienVerm.length){
            this.addImmobilieVerm();
          } else {
            this.immobilienVerm.forEach( (immo, index, immoArray) => {
              this.$store.dispatch('gewerbeAddZusatzDeckung', {
                person: this.personRef,
                sb: this.matrixSelection.sb,
                produkt: produkt,
                immobilie: immo.key,
                noUpdate: (immoArray.length !== index + 1)
              });
            });
          }
        } else if (produkt !== 'SPEZ-PRIVVM') {
          // Deckung for SPEZ-PRIVVM is added in ZusatzWohnungen
          const sb = {
            gewerbe: this.matrixSelection.sb.gewerbe,
            privat: produkt === 'SPEZ-PRIVCYBER' ? '150' : this.matrixSelection.sb.privat
          };
          this.$store.dispatch('gewerbeAddZusatzDeckung', { person: this.personRef, sb, produkt });
        }

      } else {
        this.$store.dispatch('gewerbeRemoveZusatzDeckung', { person: this.personRef, produkt });
        if (value && _isFree) this.$store.dispatch('gewerbeAddZusatzDeckung', {
          person: this.personRef,
          produkt,
          sb: this.matrixSelection.sb,
          isFree: true
        });
      }
    },
    isFree(produkt) {
      return produkt === 'SPEZ-PRIVSSR' && this.ersterGF && this.personRef === this.ersterGF.key && this.gewerbeProductSelected('SPEZ-SSRG', 'vn1');
    },
    isAvailable(produkt) {
      if (produkt !== 'SPEZ-SSRG' && produkt !== 'MIETZ') return true;
      if (produkt === 'SPEZ-SSRG') {
        return this.gewerbeProductAvailable(this.$store.state.gewerbe.personen, this.$store.state.gewerbe.ui.hasMvUnternehmen, produkt);
      } else {
        return this.matrixSelection.produkte.filter(p => p === 'SPEZ-PBV').length === 0;
      }
    },
    isIncluded(produkt) {
      return produkt === 'SPEZ-PRIVZW' && this.isZwIncluded;
    },
    showSnackbar(produkt) {
      if (this.disabled) {
        this.$store.dispatch('gewerbeShowKompexHint');
      } 
      else if ( !this.isAvailable(produkt) && produkt && produkt === 'MIETZ' ) {
        this.$store.commit('setSnackbarError', {
            message: 'Um diesen Zusatzbaustein abzuschließen, ist der Baustein Immobilien-Rechtsschutz erforderlich.',
            timeout: 5000,
            closebutton: true,
            isInfo: true
          });
      }
      else if (!this.isAvailable(produkt)) {
        this.$store.dispatch('gewerbeShowDirektionsanfrage');
      }
    },  
    addImmobilieVerm() {
      const limit = 5;
      if ( this.immobilienVerm.length + 1 > limit ) {
        this.$store.dispatch('gewerbeShowDirektionsanfrage', {
          label: 'vermietete gewerbliche Immobilien',
          limit
        });
      } else {
        const immoKey = `immo${this.$store.state.gewerbe.ui.sequentialNumber}`;
        this.$store.commit('addImmobilie', {
          art: 'VERMIET',
          bezug: 'Vermieter/Verpächter',
          unit: this.unitLabels['VERMIET']
        });
        this.$store.dispatch('gewerbeAddZusatzDeckung', {
          person: this.personRef,
          sb: this.matrixSelection.sb,
          produkt: "MIETZ",
          immobilie: immoKey
        });
      }
    },
    removeImmobilie(key) {
      this.$store.dispatch('gewerbeRemoveImmobilie', { key: key });
    },
    getBeitrag(immoRef) {
      const deckung = this.deckungen.find(deckung => deckung.immoRef === immoRef);
      return deckung && deckung.praemie ? deckung.praemie["z" + this.zahlweise] : 0 ;
    },
    getObjektDefinition(immo) {
      let index = this.objektBezug.findIndex(bezug => immo.bezug === bezug);
      return index > -1 ? this.objektArt[index] : [];
    },
    getObjektArt(immo){
      return this.getObjektDefinition(immo).find(oa => oa.value === immo.art);
    },    
  }
};
</script>
<style>
.zusatzbaustein-table {
  font-size: 16px;
}

.zusatzbaustein-table .v-divider {
  color: rgba(0, 0, 0, .12);
  margin: 38px 0 40px 0;
}

.zusatzbaustein-table .v-divider.first {
  margin-top: 16px !important;
}

.zusatzbaustein-table .mylabels {
  font-size: 16px;
}

.zusatzbaustein-table .v-input--checkbox {
  display: inline-block;
  margin-bottom: 0!important;
  padding: 0!important;
}

.zusatzbaustein-table .checkbox-container {
  position: relative;
}

.zusatzbaustein-table .checkbox-overlay {
  position: absolute;
  left: 0;
  top: 0;
  width: 32px;
  height: 32px;
  cursor: pointer;
}

.zusatzbaustein-table .zusatz--column {
  text-align: right;
  padding-right: 48px !important;
}

.zusatzbaustein-table .cursor--pointer {
  cursor: pointer;
}
</style>
